import { Check, Close, DeleteOutlined, HttpsOutlined, MoveDownOutlined, Save, ShoppingCartOutlined, TrendingDownOutlined, DownloadOutlined } from '@mui/icons-material';
import { Box, Button, CircularProgress, Stack, Tooltip } from '@mui/material';
import * as React from 'react';
import SplitButton from '../../Shared/SplitButton';
import { useTranslation } from 'react-i18next';
import { GetWarehouseDataDetailResponse, GetWarehousesPermissionsResponse } from '../../../ApiOld/Api/ApiServerVov';
import { useMediaPredicate } from 'react-media-hook';

export interface WarehouseMenuButtonsProps {
    warehouseData: Partial<GetWarehouseDataDetailResponse> | null;
    permissions: GetWarehousesPermissionsResponse | null;
    saveDone: boolean;
    error: number;
    isCentral: boolean;
    isSave: boolean;
    isNew: boolean;
    saveWarehouse: (close: boolean) => void;
    handlePurchase: () => void;
    handleBlock: () => void;
    handleOut: () => void;
    handleUtility: () => void;
    handleWriteOff: () => void;
    handleXls: () => void;
    onBuildingNameClick?: () => void
}

export default function WarehouseMenuButtons(props: Readonly<WarehouseMenuButtonsProps>) {
    const { permissions, warehouseData, saveDone, error, isCentral, isSave, isNew, saveWarehouse, handlePurchase, handleBlock, handleOut, handleUtility, handleWriteOff, handleXls, onBuildingNameClick } = props;
    const { t } = useTranslation();
    const [saving, setSaving] = React.useState(false);
    const biggerThan700 = useMediaPredicate("(min-width: 1100px)");

    React.useEffect(() => {
        if (saveDone)
            setSaving(false);
    }, [saveDone]);

    return (
        <Stack spacing={2} direction={'row'} mr={2}>
            {isSave && saveDone && !saving && <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {!error && <Check color='success' />}
                {error !== 0 && <Close color='error' />}
            </Box>}
            {isSave && !saving && <SplitButton selectedIndexInput={0} disabled={!warehouseData?.name || warehouseData.name.length < 1 || (warehouseData.id !== 0 && !permissions?.stockWarehousesEdit)} selectOnClick={true} variant='contained' options={[t('save'), t('saveAndClose')]}
                startIconSplitButton={<Save />}

                onMenuClick={(e) => {
                    if (e === 0) {
                        setSaving(true);
                        saveWarehouse(false);
                    }
                    else if (e === 1) {
                        setSaving(true);
                        saveWarehouse(true);
                    }
                }}></SplitButton>}
            {isSave && saving && <CircularProgress color='primary' />}
            {!isNew && <Button onClick={handlePurchase} startIcon={<ShoppingCartOutlined />} disabled={!warehouseData || (warehouseData.id !== 0 && !permissions?.stockWarehousesEdit)} variant='contained' size='small'>{t('warehouses.purchase')}</Button>}
            {!isNew && isCentral && <Button onClick={handleBlock} startIcon={<HttpsOutlined />} disabled={!warehouseData || (warehouseData.id !== 0 && !permissions?.stockWarehousesEdit) || (warehouseData.id !== 0 && !permissions?.stockListsStockPermBlock)} variant='contained' size='small'>{t('warehouses.reservation')}</Button>}
            {!isNew && <Button onClick={handleOut} startIcon={<MoveDownOutlined />} disabled={!warehouseData || (warehouseData.id !== 0 && !permissions?.stockWarehousesEdit)} variant='contained' size='small'>{t('warehouses.transfer')}</Button>}
            {!isNew && <Button onClick={handleUtility} startIcon={<TrendingDownOutlined />} disabled={!warehouseData || (warehouseData.id !== 0 && !permissions?.stockWarehousesEdit)} variant='contained' size='small'>{t('warehouses.consumption')}</Button>}
            {!isNew && <Button onClick={handleWriteOff} startIcon={<DeleteOutlined />} disabled={!warehouseData || (warehouseData.id !== 0 && !permissions?.stockWarehousesEdit)} variant='contained' size='small'>{t('warehouses.writeOff')}</Button>}
            {/* <Button onClick={handleXls} startIcon={<DownloadOutlined />} variant='contained' size='small'></Button> */}
            {warehouseData?.buildingId && biggerThan700 && <Box sx={{ display: 'flex', margin: '8px 20px', flexDirection: 'column', height: '32px' }}>
                <Tooltip title={t('GoToProjectDetail')} enterTouchDelay={0}>
                    <h6
                        onClick={onBuildingNameClick}
                        style={{
                            cursor: 'pointer',
                            marginTop: 5
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                    >
                        {warehouseData?.buildingName ?? ''}
                    </h6>
                </Tooltip>
            </Box>}
        </Stack>
    );
}
